import { SVGProps } from 'react';

const Facility = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M12.25 12a.25.25 0 0 0-.25-.25h-2a.25.25 0 0 0-.25.25v2.25h2.5V12Zm8 9V8.487L12 4.82 3.75 8.487V21a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .445-.686l9-4 .075-.028a.75.75 0 0 1 .535.028l9 4c.27.12.445.39.445.686v13a.75.75 0 0 1-1.5 0Zm-6.5-.75h2.5v-6.5h-2.5v6.5Zm-6 0h4.5v-4.5h-4.5v4.5Zm6-8H17a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-.75.75H7a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 .75-.75h1.25V12A1.75 1.75 0 0 1 10 10.25h2A1.75 1.75 0 0 1 13.75 12v.25Z"
    />
  </svg>
);

export default Facility;
